import React, {useEffect, useState} from 'react';
import {callApi} from "../../../connection/ClientApi";
import {groupedList} from "components/utils/ListUtility";
import Product from "../product/Product";
import EmptyBox from "components/emptyBox/EmptyBox";
import Pagination from "components/list/Pagination";
import {useHistory} from "react-router-dom";
import {IsF, IsLP, IsLP_MP, IsLP_MP_SP, IsM, IsMP, IsSP, IsT} from "my-styles/media/media";
import {Divider} from '@material-ui/core';
import Urls from "../../../connection/Urls";
import messages from "res/messages/farsi";
import {basketViewModel} from "../../../viewModels/Basket.viewModel";
import queryString from 'query-string';
import {categoryViewModel} from "../../../viewModels/Category.viewModel";
import IconTitleButton from "components/buttons/IconTitleButton";
import ScrollableTitleImage from "components/imageList/ScrollableTitleImage";
import IconTitleValue from "components/textValue/IconTitleValue";
import SelectableItemList from "components/list/SelectableItemList";

import ICSort from "res/images/sort.png";
import {Helmet} from "react-helmet";

export default function Supplier(props) {

    const history = useHistory()
    const urlParams = queryString.parse(props.location.search)

    const [limit] = useState(15)
    const [pages, setPages] = useState([])
    const [products, setProducts] = useState([])
    const [categories, setCategories] = useState([])
    const [selectedCategory, setSelectedCategory] = useState(undefined)
    const [showEmptyBox, setShowEmptyBox] = useState(false)

    function requestProductsCount(selectedCategory) {
        let params = new FormData()
        params.append("supplier_id", (urlParams && urlParams.s) ? urlParams.s : "")
        params.append("category_id", (urlParams && urlParams.c) ? urlParams.c : selectedCategory && selectedCategory.childs.length > 0 ? selectedCategory.childs[0].id : "")
        callApi(Urls.getProductsCount, params, (data) => {
            setProducts([])
            if (parseInt(data.count) === 0) {
                setShowEmptyBox(true)
            } else {
                setShowEmptyBox(false)
                let number = data.count / limit
                if (data.count % limit > 0) {
                    number++
                }
                let tempPages = []
                for (let i = 1; i <= number; i++) {
                    tempPages.push({
                        number: i,
                        selected: i === parseInt(urlParams.p)
                    })
                }
                setPages(tempPages)
                requestProducts(selectedCategory)
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestProducts(selectedCategory) {
        let params = new FormData()
        params.append("limit", limit)
        params.append("page", (urlParams && urlParams.p) ? urlParams.p : 1)
        params.append("supplier_id", (urlParams && urlParams.s) ? urlParams.s : "")
        params.append("category_id", (urlParams && urlParams.c) ? urlParams.c : selectedCategory && selectedCategory.childs.length > 0 ? selectedCategory.childs[0].id : "")
        params.append("sort", urlParams.sort ? urlParams.sort : "")
        callApi(Urls.getProducts, params, (data) => {
            setProducts([])
            let products = basketViewModel.checkLocalBasket(data.list)
            let constLimit = IsLP_MP() ? 5 : IsSP() ? 4 : IsT() ? 3 : IsF() ? 2 : IsM() ? 2 : 1
            let emptyCount = constLimit - (products.length % constLimit)
            setProducts(groupedList(products, constLimit, emptyCount))
        }, () => {
            setProducts([])
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestCategoriesBySupplier() {
        const params = new FormData()
        params.append("supplier_ids", (urlParams && urlParams.s) ? urlParams.s : "0")
        categoryViewModel.requestCategoriesBySupplier(params, (data) => {
            let selectedCategory = undefined
            if (data && data.list && data.list.length > 0) {
                setCategories(data.list)
                if (urlParams && urlParams.c) {
                    for (let category of data.list) {
                        for (let child of category.childs) {
                            if (child.id === urlParams.c) {
                                selectedCategory = category
                            }
                        }
                    }
                } else {
                    selectedCategory = data.list[0]
                }
            } else {
                setCategories([])
            }
            setSelectedCategory(selectedCategory)
            requestProductsCount(selectedCategory)
        })
    }

    function onNextClick() {
        pushToHistory({
            c: urlParams.c,
            s: urlParams.s,
            sort: urlParams.sort,
            p: (parseInt(urlParams.p) + 1)
        })
    }

    function onBackClick() {
        pushToHistory({
            c: urlParams.c,
            s: urlParams.s,
            sort: urlParams.sort,
            p: (parseInt(urlParams.p) - 1)
        })
    }

    function onNumberClick(number) {
        pushToHistory({
            c: urlParams.c,
            s: urlParams.s,
            sort: urlParams.sort,
            p: number
        })
    }

    function pushToHistory(value) {
        let path = '/supplier?'
        if (value.c) {
            path += 'c=' + value.c + '&'
        }
        if (value.s) {
            path += 's=' + value.s + '&'
        }
        if (value.sort) {
            path += 'sort=' + value.sort + '&'
        }
        if (path.endsWith("&")) {
            path = path.substring(0, path.length - 1)
        }
        path += '&p=' + value.p

        props.onNavigate(history, path)
    }

    function sort() {
        return <div className="marginTopBottomSmall fullWidth">
            <div className="horizontalFullScreen">
                <IconTitleValue
                    titleClassName={"mediumTextBold blueColor_8"}
                    icon={<img alt="" src={ICSort} className="xSmallIcon marginTopSmall marginRightSmall"/>}
                    title={messages.sort}/>
                <div className="marginTopXSmall fullWidth" style={{overflow: "hidden"}}>
                    <SelectableItemList
                        shadow={"0px"}
                        items={[
                            {title: messages.newest, id: 1, selected: urlParams && parseInt(urlParams.sort) === 1},
                            {title: messages.lowCost, id: 2, selected: urlParams && parseInt(urlParams.sort) === 2},
                            {title: messages.highCost, id: 3, selected: urlParams && parseInt(urlParams.sort) === 3},
                            {title: messages.famous, id: 4, selected: urlParams && parseInt(urlParams.sort) === 4},
                            {title: messages.highDiscount, id: 5, selected: urlParams && parseInt(urlParams.sort) === 5}
                        ]}
                        fontSize={"smallTextBold"}
                        itemsPerView={IsLP() ? 8 : IsMP() ? 7 : IsSP() ? 5 : 0}
                        onItemSelected={(index, item) => {
                            pushToHistory({
                                p: 1,
                                c: urlParams.c,
                                sort: item.id,
                                s: urlParams.s
                            })
                        }}/>
                </div>
            </div>
        </div>
    }

    function categoryList() {
        if (categories.length > 0) {
            return <div>
                {categories.map((category, index) => {
                    return (<div key={index} className="center">
                        <IconTitleButton
                            width={"100%"}
                            hover={selectedCategory ? selectedCategory.id === category.id ? "var(--pink_1)" : "var(--black)" : "var(--black)"}
                            textcolor={selectedCategory ? selectedCategory.id === category.id ? "var(--pink_1)" : "var(--black)" : "var(--black)"}
                            fontSize="smallTextBold"
                            icon={<img className="largeIcon" src={category.image} alt=""/>}
                            title={category.title}
                            onClick={() => {
                                pushToHistory({
                                    c: category.childs[0].id,
                                    s: urlParams.s,
                                    sort: urlParams.sort,
                                    p: 1
                                })
                            }}/>
                        <Divider/>
                    </div>)
                })}
            </div>
        }
    }

    function categoryChildList() {
        if (selectedCategory && selectedCategory.childs && selectedCategory.childs.length > 0) {
            return <div>
                <ScrollableTitleImage
                    itemWidth={"10em"}
                    items={
                        selectedCategory.childs.map((categoryChild) => {
                            return {
                                title: categoryChild.title,
                                image: categoryChild.image,
                                selected: urlParams.c ? categoryChild.id === urlParams.c : categoryChild.id === selectedCategory.childs[0].id,
                                onClick: () => {
                                    pushToHistory({
                                        p: 1,
                                        c: categoryChild.id,
                                        sort: urlParams.sort,
                                        s: urlParams.s
                                    })
                                }
                            }
                        })
                    }
                    itemsPerView={IsLP_MP() ? 7 : IsSP() ? 6 : IsT() ? 5 : 4}/>
                <Divider/>
            </div>
        }
    }

    function productList() {
        if (products.length > 0) {
            return <div>
                <div>
                    {products.map((productGroup, index) => {
                        return (<div key={index} className="horizontalFullScreen center">
                            {productGroup.map((product, index1) => {
                                return <div key={index1} className="categoryProduct">
                                    <Product {...props} data={product}/>
                                </div>
                            })}
                        </div>)
                    })}
                </div>
                {pages.length > 0 &&
                <div style={{float: "left"}}>
                    <br/>
                    <Pagination
                        pages={pages}
                        onNumberClick={onNumberClick}
                        onNextClick={onNextClick}
                        onBackClick={onBackClick}/>
                </div>
                }
            </div>
        }
    }

    useEffect(() => {
        requestCategoriesBySupplier()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location.search])

    return (<div>
        <Helmet>
            <title>ØµØ±ÙÙ ÙØ§Ø±Ú©Øª </title>
            <meta property="og:image" content="%PUBLIC_URL%/favicon.ico" />
            <meta property="og:url" content="https://sarfemarket.ir/" />
        </Helmet>
        {IsLP_MP_SP() &&
        <div>
            <div className="fullWidth horizontalFullScreen">
                <div className="oneFromFive">
                    {categoryList()}
                </div>
                <div>
                    <Divider orientation={"vertical"}/>
                </div>
                <div className="fourFromFive">
                    {sort()}
                    <Divider/>
                    {categoryChildList()}
                    {productList()}
                    {showEmptyBox &&
                    <div className="marginTopBottomMedium">
                        <EmptyBox message={messages.productListEmpty}/>
                    </div>
                    }
                </div>
            </div>
        </div>
        }
        {!IsLP_MP_SP() &&
        <div className="paddingTopSmall">
            <div className={urlParams && urlParams.c ? "threeFromFourInWebFullInMobile" : "fullWidth"}>
                {sort()}
                <Divider/>
                {categoryChildList()}
                {productList()}
                {showEmptyBox &&
                <div className="marginTopBottomMedium">
                    <EmptyBox message={messages.productListEmpty}/>
                </div>
                }
            </div>
        </div>
        }
    </div>)

}